import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import BuyHome from './pages/BuyHome';
import RefinanceHome from './pages/RefinanceHome';
import ReverseMortgage from './pages/ReverseMortgage';
import UnderConstruction from './components/UnderConstruction';
import './App.css';

// Check if the user is a search engine bot
const isSearchEngineBot = (): boolean => {
  if (typeof window === 'undefined' || !window.navigator) {
    return false;
  }

  const userAgent = window.navigator.userAgent.toLowerCase();
  
  // Common search engine bot user agents
  const botPatterns = [
    'googlebot',
    'bingbot',
    'slurp', // Yahoo
    'duckduckbot',
    'baiduspider',
    'yandexbot',
    'sogou',
    'exabot',
    'facebot',
    'ia_archiver',
    'facebookexternalhit',
    'twitterbot',
    'rogerbot',
    'linkedinbot',
    'embedly',
    'quora link preview',
    'showyoubot',
    'outbrain',
    'pinterest',
    'developers.google.com/+/web/snippet',
    'slackbot',
    'vkShare',
    'W3C_Validator',
    'whatsapp',
    'flipboard',
    'tumblr',
    'bitlybot',
    'skypeuripreview',
    'nuzzel',
    'discordbot',
    'qwantify',
    'pinterestbot',
    'bitrix link preview',
    'redditbot',
    'applebot',
    'flipboardproxy',
    'tweetmemebot',
    'pagefreezer',
    'google page speed',
    'semrushbot',
    'ahrefsbot',
    'mj12bot',
    'dotbot',
    'megaindex',
    'blexbot',
    'dotbot',
  ];

  return botPatterns.some(pattern => userAgent.includes(pattern));
};

const App: React.FC = () => {
  const [showConstruction, setShowConstruction] = useState<boolean>(true);

  useEffect(() => {
    // Check if user is a bot on client side
    const botCheck = isSearchEngineBot();
    
    // Check for bypass query parameter (for testing)
    const urlParams = new URLSearchParams(window.location.search);
    const bypass = urlParams.get('bypass') === 'true';
    
    // Show construction page to regular users, real content to bots or if bypass is enabled
    setShowConstruction(!botCheck && !bypass);
  }, []);

  return (
    <Router>
      {showConstruction ? (
        <UnderConstruction />
      ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buy-home" element={<BuyHome />} />
          <Route path="/refinance-home" element={<RefinanceHome />} />
          <Route path="/reverse-mortgage" element={<ReverseMortgage />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;
